// ! marked for deletion
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import cloudCMAEmblem from "../../assets/images/cloud-cma-badge-tiny.svg";
import cloudStreamsEmblem from "../../assets/images/cloud-streams-badge-tiny.svg";
import cloudMLXEmblem from "../../assets/images/cloud-mlx-badge-tiny.svg";
import cloudAttractEmblem from "../../assets/images/cloud-attract-badge-tiny.svg";
import CircleStar from "../components/icons/CircleStar";
import StarBorder from "../components/icons/StarBorder";
import { isArray } from "util";

// Container
export const PlanCardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 220px;
  max-width: 220px;
  /* margin: 0 auto; */
  overflow: hidden;
  padding: 10px 20px 20px;
  border-radius: 6px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  background-color: white;
  ${({ featured }) =>
    featured &&
    `
      border: 2px solid #9f39f8;
    `};
  ${({ isSpecialOffer }) =>
    isSpecialOffer &&
    `
      padding-top: 26px;
    `};
`;

export const SpecialOfferBanner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  min-height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 500;
  font-size: 12px;
  font-weight: normal;
  color: #2d335d;
  letter-spacing: 0;
  text-align: center;
  line-height: 20px;
  background-color: #e1e5e9;
  svg {
    margin-right: 5px;
    width: 14px;
    fill: #2d335d;
  }
`;

// Callout
export const PlanCallout = ({ name }) => {
  switch (name) {
    case "Cloud Attract":
      return (
        <PlanCalloutWrapper color={name}>
          <IconWrapper color={name}>
            <StarBorder />
          </IconWrapper>
          Premium Tool
        </PlanCalloutWrapper>
      );
    case "Cloud MLX":
    case "Cloud Streams":
    case "Cloud CMA":
      return <PlanCalloutWrapper color={name}>Single Tool</PlanCalloutWrapper>;
    case "Essentials":
      return (
        <PlanCalloutWrapper color={name}>
          Limited Time Discount
        </PlanCalloutWrapper>
      );
    case "Suite":
      return (
        <PlanCalloutWrapper color={name} style={{ marginTop: 0 }}>
          <IconWrapper color={name}>
            <CircleStar />
          </IconWrapper>
          Best Deal
        </PlanCalloutWrapper>
      );
    default:
      return null;
  }
};

const IconWrapper = styled.div`
  width: 18px;
  height: 18px;
  margin-right: 8px;
  svg {
    fill: ${({ color }) => getCalloutColor(color)};
  }
`;

PlanCallout.propTypes = {
  name: PropTypes.string
};

function getCalloutColor(name) {
  switch (name) {
    case "Cloud Attract":
      return "#FD5154";
    case "Cloud Streams":
      return "#0AA1DC";
    case "Cloud CMA":
      return "#20B575";
    case "Cloud MLX":
    case "Essentials":
      return "#3A7ABE";
    case "Suite":
      return "#A33DFC";
    default:
      return "#566373";
  }
}

const PlanCalloutWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px auto;
  font-weight: 500;
  font-size: 12px;
  color: ${({ color }) => getCalloutColor(color)};
`;

// Plan Name
export const PlanName = styled.h4`
  margin: 0 auto 2px;
  font-weight: 500;
  font-size: 20px;
  color: #131945;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  text-decoration: none;
`;

export const PlanTagline = styled.p`
  width: 100%;
  margin: 0;

  font-size: 14px;
  color: #566373;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
`;

// Product Emblems
export const PlanProducts = ({
  products,
  showAvailability = false,
  ...props
}) => {
  return isArray(products) ? (
    <ProductsLayout {...props} productCount={products.length}>
      {products.map((p) => (
        <ProductEmblem
          product={p.name}
          key={p.key}
          isAvailable={showAvailability ? p.isAvailable : true}
        />
      ))}
    </ProductsLayout>
  ) : (
    <ProductsLayout {...props} productCount={1}>
      <ProductEmblem
        product={products.name}
        key={products.key}
        isAvailable={showAvailability ? products.isAvailable : true}
      />
    </ProductsLayout>
  );
};

PlanProducts.defaultProps = {
  showAvailability: false
};

export const ProductsLayout = styled.div`
  ${({ productCount }) => {
    switch (productCount) {
      case 1:
      case 2:
        return css`
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          padding: 20px 0;
          > * {
            padding: 0 10px;
          }
        `;
      case 3:
        return css`
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 190px;
          padding: 20px 0;
          & > * {
            padding: 0 5px;
          }
        `;
      case 4:
        return css`
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          width: 144px;
          padding: 10px 0;
          > a:first-of-type,
          a:nth-of-type(2) {
            margin-bottom: 10px;
          }
          > * {
            padding: 0 10px;
          }
        `;
      default:
        return null;
    }
  }};
`;

const ProductEmblemWrapper = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  font-size: 14px;
  color: #566373;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  img {
    margin: 0 auto 2px;
    min-width: 52px;
    max-width: 52px;
    min-height: 52px;
    ${({ isAvailable }) =>
      !isAvailable &&
      css`
        opacity: 0.5;
      `};
  }
  &::after {
    ${({ isAvailable }) =>
      !isAvailable &&
      css`
        content: "*";
        position: absolute;
        top: -6px;
        right: 8px;
        color: #89929d;
        font-size: 20px;
        line-height: 20px;
      `};
  }
`;

const ProductName = styled.span`
  color: ${({ product }) => getCalloutColor(product)};
  opacity: ${({ isAvailable }) => (isAvailable ? 1 : 0.5)};
`;

export const ProductEmblem = ({ product, isAvailable }) => {
  switch (product) {
    case "Cloud CMA":
      return (
        <ProductEmblemWrapper
          isAvailable={isAvailable}
          href="/tools/cma"
          target="_blank"
          data-testid="product-emblem-wrapper">
          <img src={cloudCMAEmblem} />
          <ProductName product={product} isAvailable={isAvailable}>
            CMA
          </ProductName>
        </ProductEmblemWrapper>
      );
    case "Cloud Streams":
      return (
        <ProductEmblemWrapper
          isAvailable={isAvailable}
          href="/tools/streams"
          target="_blank"
          data-testid="product-emblem-wrapper">
          <img src={cloudStreamsEmblem} />
          <ProductName product={product} isAvailable={isAvailable}>
            Streams
          </ProductName>
        </ProductEmblemWrapper>
      );
    case "Cloud MLX":
      return (
        <ProductEmblemWrapper
          isAvailable={isAvailable}
          href="/tools/mlx"
          target="_blank"
          data-testid="product-emblem-wrapper">
          <img src={cloudMLXEmblem} />
          <ProductName product={product} isAvailable={isAvailable}>
            MLX
          </ProductName>
        </ProductEmblemWrapper>
      );
    case "Cloud Attract":
      return (
        <ProductEmblemWrapper
          isAvailable={isAvailable}
          href="/tools/attract"
          target="_blank"
          data-testid="product-emblem-wrapper">
          <img src={cloudAttractEmblem} />
          <ProductName product={product} isAvailable={isAvailable}>
            Attract
          </ProductName>
        </ProductEmblemWrapper>
      );
    default:
      return null;
  }
};

// Plan Prices
export const PlanPrice = ({
  discountsLoading,
  discountFound,
  discount,
  plan
}) => {
  if (discountsLoading) return <span>———</span>;
  return (
    <PriceWrapper>
      {discountFound && discount.amount !== 0 ? (
        <Fragment>
          <OldPrice>
            <LineThrough />
            <span>{plan.price}</span>
          </OldPrice>
          {plan.price - discount.amount <= 0 ? (
            <span>FREE</span>
          ) : (
            <Price>{plan.price - discount.amount}</Price>
          )}
        </Fragment>
      ) : plan.price === 0 ? (
        <span>FREE</span>
      ) : (
        <Price>{plan.price}</Price>
      )}
    </PriceWrapper>
  );
};

PlanPrice.propTypes = {
  discountsLoading: PropTypes.bool.isRequired,
  discountFound: PropTypes.bool.isRequired
};

export const PlanPriceLayout = styled.div`
  margin: 0 auto 20px;
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin: 0;

  font-size: 24px;
  color: #131945;
  letter-spacing: 0;
  line-height: 30px;
`;

export const LineThrough = styled.div`
  position: absolute;
  top: 50%;
  left: -4px;
  right: -4px;
  transform: translateY(-50%);
  height: 3px;
  background-color: #9013fe;
  opacity: 0.8;
`;

export const OldPrice = styled.span`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-right: 14px;
  span {
    opacity: 0.5;
    text-decoration: line-through 3px solid #9013fe;
    &::before {
      content: '$';
    }
    &::after {
      content: "${({ paymentInterval }) =>
        paymentInterval === "annually" ? "/yr" : "/mo"}";
      font-size: 18px;
      line-height: 30px;
      color: #89929d;
    }
  }
`;

export const Price = styled.span`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  &::before {
    content: '$';
  }
  &::after {
    content: "${({ paymentInterval }) =>
      paymentInterval === "monthly" ? "/mo" : "/yr"}";
    font-size: 18px;
    line-height: 30px;
    color: #89929d;
  }
`;
